import { render, staticRenderFns } from "./RiskUnit.vue?vue&type=template&id=7994e331&scoped=true"
import script from "./RiskUnit.vue?vue&type=script&lang=js"
export * from "./RiskUnit.vue?vue&type=script&lang=js"
import style0 from "./RiskUnit.vue?vue&type=style&index=0&id=7994e331&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7994e331",
  null
  
)

export default component.exports